
export class PendoHelper {
    initializePendo(userId, organizationName) {
        if(!userId || userId.length === 0) return;
        // eslint-disable-next-line no-undef
        pendo.initialize({
            visitor: {
              id: userId
            },
            account: {
              id: organizationName
            }
          });
    }

    trackEvent(eventName) {
        // eslint-disable-next-line no-undef
        pendo.track(eventName);
    }

    trackEventWithProperties(eventName, properties) {
        // eslint-disable-next-line no-undef
        pendo.track(eventName, properties);
    }
}

export const PendoHelperSingleton = new PendoHelper();